const GENERAL_ERRORS = {
  SOMETHING_WRONG:
    'Lo sentimos!, Algo ha salido mal, inténtalo de nuevo. Si el problema persiste contacta a soporte.',
  INCORRECT_REPORTING:
    'No se encontraron registros para exportar. Intenta con otra opción de filtrado.'
};

export default GENERAL_ERRORS;
